export const styles = {
  toggleButtonsGroup: {
    backgroundColor: '#eeeeee',
    width: '100%',
    '& .MuiToggleButton-root': {
      textTransform: 'none',
      border: 0,
      borderRadius: '4px !important',
      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#009FDA',
        color: '#ffffff',
      },
    },
  },
  table: {
    '& .MuiTableCell-root': {
      padding: '12px',
      fontSize: '16px',
      border: '0',
      lineHeight: '1.3',
      '&:first-child': {
        minWidth: '360px',
      },
    },
    '& .MuiTableRow-root': {
      verticalAlign: 'top',
    },
  },
  chip: {
    // '&.MuiChip-root': {
    //   pointerEvents: 'none',
    //   maxHeight: '22px',
    //   border: '1px solid',
    //   borderRadius: '4px',
    //   inlineSize: 'fit-content',
    // },
    // '&.MuiChip-label': {
    //   padding: '2px 8px',
    //   marginTop: 'auto',
    // },
    height: '22px',
    borderRadius: '4px',
    '.MuiChip-label': {
      paddingLeft: '8px',
      paddingRight: '8px',
    },
    '&.MuiChip-outlinedWarning': {
      color: '#F0901E',
      borderColor: '#F0901E',
      backgroundColor: '#FFF0DD',
    },
    '&.MuiChip-outlinedSuccess': {
      color: '#33C341',
      borderColor: '#33C341',
      backgroundColor: '#EFFFEE',
    },
    '&.MuiChip-outlinedPrimary': {
      color: '#009FDA',
      borderColor: '#009FDA',
      backgroundColor: '#EAF8FF',
    },
    '&.MuiChip-outlinedError': {
      color: '#FF4D4F',
      borderColor: '#FF4D4F',
      backgroundColor: '#FFEAEA',
    },
  },
}
